import { ChangeDetectionStrategy, ChangeDetectorRef, Component, DoCheck, Input, OnInit } from '@angular/core';
import { AbstractControl, UntypedFormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AbstractInputComponent } from '@shared/form-elements/input/abstract-input/abstract-input.component';
import { ControlToKeyNamePipe } from '@shared/form-elements/pipes/control-to-key-name.pipe';
import { ValidationErrorMessagePipe } from '@shared/form-elements/pipes/validation-error-message.pipe';
import { TranslateModule } from '@ngx-translate/core';
import { SvgIconComponent } from '../../svg-icon/svg-icon.component';
import { NgIf, NgClass, NgFor } from '@angular/common';

export interface SelectOption {
    value: any;
    text: string;
}

export type SelectOptions = SelectOption[];

@Component({
    selector: 'app-select',
    templateUrl: './select.component.html',
    styleUrls: ['./select.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgIf, NgClass, FormsModule, ReactiveFormsModule, NgFor, SvgIconComponent, TranslateModule, ValidationErrorMessagePipe, ControlToKeyNamePipe]
})
export class SelectComponent extends AbstractInputComponent implements OnInit, DoCheck {
    private internalControl: AbstractControl;

    public isRequired: true | null = null;

    @Input()
    options: SelectOptions;

    constructor(private cd: ChangeDetectorRef) {
        super();
    }

    ngOnInit(): void {
        this.internalControl = { ...this.control } as AbstractControl;
        this.checkIfRequired();
    }

    // Custom changeDetection
    ngDoCheck(): void {
        const { touched: internalTouched } = this.internalControl;
        const { touched } = this.control;

        if (touched !== internalTouched) {
            this.internalControl = { ...this.control } as AbstractControl;
            this.cd.markForCheck();
        }
    }

    public get showError(): boolean {
        return !!(this.control.touched && this.control.errors);
    }

    private checkIfRequired(): void {
        if (!this.formControl.validator) {
            this.isRequired = null;
            return;
        }
        const testFormControl = new UntypedFormControl('', this.formControl.validator);
        if (!testFormControl.valid) {
            this.isRequired = true;
        } else {
            this.isRequired = null;
        }
    }
}
